import React, { useState } from 'react';
import { CustomCursor } from './components/CustomCursor';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { BookingPanel } from './components/BookingPanel';
import { Services } from './components/Services';
import { Barbers } from './components/Barbers';
import { BeforeAfter } from './components/BeforeAfter';
import { Reviews } from './components/Reviews';
import { Location } from './components/Location';
import { Gallery } from './components/Gallery';
import { Stats } from './components/Stats';
import { Footer } from './components/Footer';
import { MobileBookBar } from './components/MobileBookBar';
export function App() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  return <div className="w-full min-h-screen bg-matte-black font-inter" data-id="element-0">
      <CustomCursor data-id="element-1" />
      <Navbar onBookClick={() => setIsBookingOpen(true)} data-id="element-2" />
      <Hero onBookClick={() => setIsBookingOpen(true)} data-id="element-3" />
      <Stats data-id="element-4" />
      <Services onBookClick={() => setIsBookingOpen(true)} data-id="element-5" />
      <Barbers onBookClick={() => setIsBookingOpen(true)} data-id="element-6" />
      <BeforeAfter data-id="element-7" />
      <Gallery data-id="element-8" />
      <Reviews data-id="element-9" />
      <Location data-id="element-10" />
      <Footer data-id="element-11" />
      <MobileBookBar onBookClick={() => setIsBookingOpen(true)} data-id="element-12" />
      <BookingPanel isOpen={isBookingOpen} onClose={() => setIsBookingOpen(false)} data-id="element-13" />
    </div>;
}